// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los números que se muestran en los display
 * @param {*} scene 
 */
export function cargaAssetsNumerosDisplay(scene) {
  scene.load.image(
    "numeroDisplay0",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay0Resized.png"
  );
  scene.load.image(
    "numeroDisplay1",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay1Resized.png"
  );
  scene.load.image(
    "numeroDisplay2",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay2Resized.png"
  );
  scene.load.image(
    "numeroDisplay3",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay3Resized.png"
  );
  scene.load.image(
    "numeroDisplay4",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay4Resized.png"
  );
  scene.load.image(
    "numeroDisplay5",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay5Resized.png"
  );
  scene.load.image(
    "numeroDisplay6",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay6Resized.png"
  );
  scene.load.image(
    "numeroDisplay7",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay7Resized.png"
  );
  scene.load.image(
    "numeroDisplay8",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay8Resized.png"
  );
  scene.load.image(
    "numeroDisplay9",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplay9Resized.png"
  );
  scene.load.image(
    "numeroDisplayVacio",
    ROUTES.rutaRuletaNumerosDisplay + "/numeroDisplayVacioResized.png"
  );
}